module.exports = __webpack_public_path__ + "static/media/manuel-fontana.538b31bf.jpg";